var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgMoneyin = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M13.136 4.233a6.738 6.738 0 1 0 0 9.534M8.265 5.25v1.125m0 5.25v1.125" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m14.631 6.379-2.27 2.27a.5.5 0 0 0 0 .706l2.27 2.27m-2.468-2.621h5.007m-7.03-2.441H7.33a1.127 1.127 0 1 0 0 2.254h1.387a1.31 1.31 0 0 1 0 2.621H6.015" })] }))); };
export default SvgMoneyin;
